module.exports = __webpack_public_path__ + "img/linkBt.0f024659.png";